export function unwrapEnvelope<T>(response: unknown): T {
  if (response !== null && typeof response === 'object' && 'data' in response) {
    return (response as { data: T }).data;
  }
  throw new Error(
    `unwrapEnvelope: response did not contain a "data" key. Got: ${JSON.stringify(response)}`,
  );
}

export function unwrapEnvelopeOr<T>(response: unknown, fallback: T): T {
  if (response !== null && typeof response === 'object' && 'data' in response) {
    return (response as { data: T }).data;
  }
  return fallback;
}
